import React, { useContext } from 'react';
import cn from 'classnames';
import StageBackground from '../../../DeviationBackground/StageBackground';
import DeviationFullView from '../../../DeviationViews/Full';
import DuperbrowsePaddles from '../../../Duperbrowse/DuperbrowsePaddles';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import { useDeviationViewContext } from '../../../Context';
import { SubscriptionPurchaseFTUEContext } from '../../../Tier/ftue/SubscriptionPurchaseFTUE/SubscriptionPurchaseFTUEContext';
import SubscriptionPurchaseFTUE from '../../../Tier/ftue/SubscriptionPurchaseFTUE/SubscriptionPurchaseFTUE';
import s from './SimpleStage.scss';
var SimpleStage = function (_a) {
    var deviation = _a.deviation;
    var needsSubscription = useSubscriptionTier(deviation).needsSubscription;
    var isTheater = useDeviationViewContext().isTheater;
    var isSubscriptionPurchaseFTUEBeingShown = !!useContext(SubscriptionPurchaseFTUEContext);
    return (React.createElement("div", { className: cn(s['stage'], needsSubscription && s['stage-locked']) },
        React.createElement(StageBackground, { deviation: deviation }),
        React.createElement("div", { className: cn(s['stage-content'], needsSubscription && s['content-locked'], isTheater && s['content-locked-theater']) },
            React.createElement(DeviationFullView, { deviation: deviation })),
        React.createElement(DuperbrowsePaddles, { className: s['duperbrowse'] }),
        isSubscriptionPurchaseFTUEBeingShown && React.createElement(SubscriptionPurchaseFTUE, null)));
};
SimpleStage.displayName = 'SimpleStage';
export default SimpleStage;
//# sourceMappingURL=SimpleStage.js.map